import React from 'react';

import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setActiveChapter } from 'redux/study/studyDetails.slice';

import styles from '../teachingStructure.module.scss';
import useOnItemSelected from './useOnItemSelected';

type Assignment = {
  id: string;
  title: string;
  duration: string;
  created_at: string;
  updated_at: string;
  type: string;
};

interface iProps {
  assignment: Assignment;
  lessonId: string;
}

const TeachingStructureAssignment: React.FC<iProps> = ({ assignment, lessonId }) => {
  const { handleOnItemSelect } = useOnItemSelected(lessonId);

  const { t } = useTranslation();
  const lang = localStorage.getItem('lang');
  const dispatch = useDispatch();
  const getDateTimeAgo = (date: string) => {
    const checkDate = DateTime.fromISO(date);
    const today = DateTime.now().startOf('day');
    const yesterday = DateTime.now().plus({ days: -1 }).startOf('day');
    if (today < checkDate) return t('study:today');
    if (yesterday < checkDate) return t('study:yesterday');
    return checkDate.setLocale(lang === 'ee' ? 'et' : lang).toRelative();
  };
  if (lessonId === assignment.id) {
    const assignmentTitle = assignment?.title;
    const assignmentType = assignment?.type;
    const title = assignmentTitle.concat(' - ', assignmentType);
    dispatch(setActiveChapter(title));
  }
  return (
    <li key={assignment.id}>
      <label>
        <div>
          {assignment.title} - <span className={styles.materialType}>{assignment.type}</span>
        </div>
        <section className={styles.select}>
          <p className={styles.assignmentDuration}>({assignment.duration} mins)</p>
          <p className={styles.assignmentTimeAgo}>{getDateTimeAgo(assignment.created_at)}</p>
          <small>{DateTime.fromISO(assignment.updated_at).setLocale(lang).toRelative()}</small>
          <input
            id={`radio_${assignment.id}`}
            type="checkbox"
            value={assignment.id}
            checked={lessonId === assignment.id}
            onChange={handleOnItemSelect(assignment.id, assignment.type)}
          />
          <span className={styles.container} />
        </section>
      </label>
    </li>
  );
};

export default TeachingStructureAssignment;
